import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-s-shimmer',
  templateUrl: './s-shimmer.component.html',
  styleUrls: ['./s-shimmer.component.scss']
})
export class SShimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
